<script>
import {cloneDeep} from "lodash";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import MaskedInput from "vue-text-mask";
export default {
  components: {
    MaskedInput,
  },
  props: {
    addNewReq: {
      type: Boolean,
      default: false,
    },
    editReqMode: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    requirements: {
      type: Array,
      default: () => [],
    },
    groupReqs: {
      type: Array,
      default: () => [],
    },
  },
  data(){
    return {
      currencyMask: createNumberMask({
        prefix: "",
        allowDecimal: true,
      }),
      reqData: {
        id: 0,
        requirementGroup: "",
        requirements: "",
        whereToSecure: "",
      },
      addMoreGrp: false,
    }
  },
  methods: {
    createNew(){
      this.$emit('add-new-req');
      this.reqData = {
        id: 0,
        order: "",
        requirementGroup: "",
        requirements: "",
        whereToSecure: "",
      }
      if(this.requirements.length){
        this.reqData.requirementGroup = this.requirements[this.requirements.length - 1].requirementGroup;
      }
    },
    onSubmitReq(reqData){
      let data = cloneDeep(reqData);
      data.order = reqData.order ? this.getExactAmt(reqData.order) : 0;
      this.$emit('save', data);
    },
    updateReq(row){
      this.reqData = cloneDeep(row);
    },
    removeReq(row){
      this.$emit('remove', row);
    },
    editReq(row){
      row.editMode = true;
      row.order = row.order.toString();
      row.editData = {
        id: cloneDeep(row.id),
        requirementGroup: cloneDeep(row.requirementGroup),
        requirements: cloneDeep(row.requirements),
        whereToSecure: cloneDeep(row.whereToSecure),
        processTypeId: cloneDeep(row.processTypeId),
        order: cloneDeep(row.order),
        editMode: false,
      }
      this.$emit('edit-req');
    },
    cancelReq(row){
      this.$emit('cancel', row.id);
    },
    cancelForm(){
      this.$emit('cancel-form');
    },
  }
};
</script>
<template>
  <table class="table table-striped table-hovered table-bordered">
    <thead>
      <tr>
        <th width="20px"></th>
        <th>Requirements</th>
        <th width="40%">Where to Secure</th>
        <th width="90px" class="text-center">Action</th>
      </tr>
    </thead>
    <tbody>
      <template v-if="loading">
        <tr>
          <td colspan="100%" class="text-center">
            <div
              class="
                d-flex
                justify-content-center
                align-items-center
              "
            >
              <div class="preloader-component me-2">
                <div class="status">
                  <div class="spinner-chase w-20px h-20px">
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                  </div>
                </div>
              </div>
              <strong>Loading...</strong>
            </div>
          </td>
        </tr>
      </template>
      <template v-if="!loading && !requirements.length && !addNewReq">
        <tr>
          <td colspan="100%" class="text-center">No data available</td>
        </tr>
      </template> 
      <template v-if="!loading && requirements.length">
        <template v-for="(y, yIndex) in groupReqs">
          <template v-if="y.group.trim() !== ''">
            <tr :key="`${yIndex}`">
              <td colspan="100%" class="text-left text-info font-weight-bold">{{ y.group }}</td>
            </tr>
          </template>
          <tr v-for="x in y.items" :key="`${yIndex}-${x.id}`">
            <template v-if="x.requirementGroup.trim() === ''">
              <td colspan="2">
                <template v-if="!x.editMode">
                  {{x.order ? `${x.order}. ` : ''}}{{ x.requirements }}
                </template>
                <template v-else>
                  <masked-input
                    autocomplete="off"
                    type="text"
                    v-model="x.order"
                    placeholder="Sort"
                    class="form-control mb-1"
                    :mask="currencyMask"
                  >
                  </masked-input>
                  <textarea
                    rows="3"
                    v-model="x.requirements"
                    placeholder="Enter Requirement..."
                    class="form-control"
                    autocomplete="off"
                  ></textarea>
                </template>
              </td>
            </template>
            <template v-else>
              <td>
              </td>
              <td>
                <template v-if="!x.editMode">
                  {{x.order ? `${x.order}. ` : ''}}{{ x.requirements }}
                </template>
                <template v-else>
                  <masked-input
                    autocomplete="off"
                    type="text"
                    v-model="x.order"
                    placeholder="Sort"
                    class="form-control mb-1"
                    :mask="currencyMask"
                  >
                  </masked-input>
                  <textarea
                    rows="3"
                    v-model="x.requirements"
                    placeholder="Enter Requirement..."
                    class="form-control"
                    autocomplete="off"
                  ></textarea>
                </template>
              </td>
            </template>
            <td>
              <template v-if="!x.editMode">
                {{ x.whereToSecure }}
              </template>
              <template v-else>
                <textarea
                  id="whereToSecure"
                  rows="3"
                  v-model="x.whereToSecure"
                  placeholder="Enter Where to Secure..."
                  class="form-control"
                  autocomplete="off"
                ></textarea>
              </template>
            </td>
            <td class="text-center">
              <template v-if="!x.editMode">
                <i class="bx bx-edit text-primary font-size-16 me-2 cursor-pointer" @click="editReq(x)"></i>
                <i class="bx bx-trash text-danger font-size-16 cursor-pointer" @click="removeReq(x)"></i>
              </template>
              <template v-else>
                <div class="mb-1">
                  <button type="button" class="btn btn-success btn-sm" @click="onSubmitReq(x)">
                    <span class="bx bx-check"></span>
                  </button>
                </div>
                <div>
                  <button type="button" class="btn btn-danger btn-sm" @click="cancelReq(x)">
                    <i class="bx bx-x"></i>
                  </button>
                </div>
              </template>
            </td>
          </tr>
        </template>
      </template>
      <template v-if="!addNewReq && !editReqMode">
        <tr>
          <td colspan="100%" class="text-center text-info font-weight-bold cursor-pointer" @click="createNew"><i class="bx bx-plus"></i> Add New Requirement</td>
        </tr>
      </template>
      <template v-if="addNewReq && !editReqMode">
        <tr>
          <td></td>
          <td>
            <div class="d-flex mb-1" v-if="!addMoreGrp">
              <select class="form-select font-weight-bold text-info" v-model="reqData.requirementGroup" >
                <option value="">No group</option>
                <option v-for="(req, reqIndex) in groupReqs" :value="req.group" :key="reqIndex">{{ req.group }}</option>
              </select>
              <button type="button" @click="addMoreGrp = true" class="btn btn-outline-info btn-sm"><i class="bx bx-plus mx-1"></i></button>
            </div>
            <div v-else class="d-flex mb-2">
              <input 
                type="text" 
                v-model="reqData.requirementGroup"
                class="form-control"
                placeholder="Enter Requirement Group..."
                autocomplete="off"
              >
              <button type="button" @click="addMoreGrp = false" class="btn btn-outline-danger btn-sm"><i class="bx bx-x mx-1"></i></button>
            </div>
            <div class="d-flex">
              <masked-input
                autocomplete="off"
                type="text"
                v-model="reqData.order"
                placeholder="Sort"
                class="form-control"
                style="width:70px;"
                :mask="currencyMask"
              >
              </masked-input>
              <textarea
                rows="3"
                v-model="reqData.requirements"
                placeholder="Enter Requirement..."
                class="form-control"
                autocomplete="off"
              ></textarea>
            </div>
          </td>
          <td>
            <textarea
              rows="3"
              v-model="reqData.whereToSecure"
              placeholder="Enter Where to Secure..."
              class="form-control"
              autocomplete="off"
            ></textarea>
          </td>
          <td>
            <div class="mb-1">
              <button type="button" class="btn btn-success btn-sm" @click="onSubmitReq(reqData)">
                <span class="bx bx-check"></span>
              </button>
            </div>
            <div>
              <button type="button" class="btn btn-danger btn-sm" @click="cancelForm">
                <i class="bx bx-x"></i>
              </button>
            </div>
          </td>
        </tr>
      </template>
    </tbody>
  </table>
</template>